import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormInput } from 'modules';
import DruhPrijmuSelect from 'components/DruhPrijmuSelect';

interface PartnerFormProps {
  isViewMode: boolean;
  values: any;
  onChange: (e: React.ChangeEvent) => void;
}

const PartnerForm = ({ isViewMode, values, onChange }: PartnerFormProps) => {
  const onFormInputChange = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    onChange({
      target: {
        name: 'client2',
        value: {
          ...values,
          [name]: value,
        },
      },
    } as any);
  };

  return (
    <>
      <Row>
        <Col>
          <h5>Manžel / Manželka</h5>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <FormInput
            name="lastName"
            label="Příjmení"
            required
            readOnly={isViewMode}
            value={values.lastName}
            onChange={onFormInputChange}
          />
        </Col>
        <Col sm={6}>
          <FormInput
            name="firstName"
            label="Jméno"
            required
            readOnly={isViewMode}
            value={values.firstName}
            onChange={onFormInputChange}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <FormInput
            name="mobil"
            label="Mobil"
            required
            readOnly={isViewMode}
            value={values.mobil}
            onChange={onFormInputChange}
          />
        </Col>
        <Col sm={3}>
          <FormInput
            name="email"
            label="E-mail"
            required
            readOnly={isViewMode}
            value={values.email}
            onChange={onFormInputChange}
          />
        </Col>
        <Col sm={3}>
          <FormInput
            name="cislo_op"
            label="Číslo OP"
            required
            readOnly={isViewMode}
            value={values.cislo_op}
            onChange={onFormInputChange}
          />
        </Col>
        <Col sm={3}>
          <FormInput
            name="rodne_cislo"
            label="Rodné číslo"
            required
            readOnly={isViewMode}
            value={values.rodne_cislo}
            onChange={onFormInputChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={4} xs={8}>
          <FormInput
            name="street"
            label={'Ulica'}
            required
            readOnly={isViewMode}
            value={values.street}
            onChange={onFormInputChange}
          />
        </Col>
        <Col md={2} xs={4}>
          <FormInput
            name="houseNumber"
            label={'Súpisné č.'}
            required
            readOnly={isViewMode}
            value={values.houseNumber}
            onChange={onFormInputChange}
          />
        </Col>
        <Col md={4} xs={8}>
          <FormInput
            name="city"
            label={'Mesto'}
            required
            readOnly={isViewMode}
            value={values.city}
            onChange={onFormInputChange}
          />
        </Col>
        <Col md={2} xs={4}>
          <FormInput
            name="zipCode"
            label={'PSČ'}
            required
            readOnly={isViewMode}
            value={values.zipCode}
            onChange={onFormInputChange}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormInput
            type="checkbox"
            name="mailingAddress"
            label={'Korešpondenčná adresa'}
            readOnly={isViewMode}
            checked={!!values.mailingAddress}
            onChange={onFormInputChange}
          />
        </Col>
      </Row>

      {values.mailingAddress === true && (
        <Row>
          <Col md={4} xs={8}>
            <FormInput
              name="mailingAddressStreet"
              label={'Koresp. ulica'}
              readOnly={isViewMode}
              value={values.mailingAddressStreet}
              onChange={onFormInputChange}
            />
          </Col>
          <Col md={2} xs={4}>
            <FormInput
              name="mailingAddressHouseNumber"
              label={'Koresp. súpisné č.'}
              readOnly={isViewMode}
              value={values.mailingAddressHouseNumber}
              onChange={onFormInputChange}
            />
          </Col>
          <Col md={4} xs={8}>
            <FormInput
              name="mailingAddressCity"
              label={'Koresp. mesto'}
              readOnly={isViewMode}
              value={values.mailingAddressCity}
              onChange={onFormInputChange}
            />
          </Col>
          <Col md={2} xs={4}>
            <FormInput
              name="mailingAddressZipCode"
              label={'Koresp. PSČ'}
              readOnly={isViewMode}
              value={values.mailingAddressZipCode}
              onChange={onFormInputChange}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col sm={5}>
          <DruhPrijmuSelect
            name="income"
            label={'Príjem'}
            required={true}
            disabled={isViewMode}
            value={values?.income}
            onChange={onFormInputChange}
          />
        </Col>
        <Col sm={3}>
          <FormInput
            type="number"
            name="incomeValue"
            label={'Výška príjmu'}
            min={0}
            disabled={isViewMode}
            value={values?.incomeValue}
            onChange={onFormInputChange}
          />
        </Col>
      </Row>
    </>
  );
};

export default PartnerForm;
